import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AppThunk } from 'store/types';

interface NotificationState {
  date: string | null;
  remainder: number | null;
  project: string;
  isPilot: boolean | null;
}

const initialState: NotificationState = {
  date: null,
  remainder: null,
  project: '',
  isPilot: null,
};

const reset: CaseReducer<NotificationState> = () => initialState;

const remainder: CaseReducer<NotificationState, PayloadAction<number>> = (state, action) => {
  state.remainder = action.payload;
};

const project: CaseReducer<NotificationState, PayloadAction<string>> = (state, action) => {
  state.project = action.payload;
};

const date: CaseReducer<NotificationState, PayloadAction<string>> = (state, action) => {
  state.date = action.payload;
};

const isPilot: CaseReducer<NotificationState, PayloadAction<boolean>> = (state, action) => {
  state.isPilot = action.payload;
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    remainder,
    date,
    reset,
    project,
    isPilot,
  },
});

const {
  remainder: setRemainder,
  date: setDate,
  reset: resetData,
  isPilot: setIsPilot,
} = notificationSlice.actions;

const handleReset = (): AppThunk => dispatch => {
  dispatch(resetData());
};

export const setNotification =
  (date: string, remainder: number, isPilot: boolean): AppThunk =>
  dispatch => {
    dispatch(setRemainder(remainder));
    dispatch(setDate(date));
    dispatch(setIsPilot(isPilot));
  };

export { resetData, handleReset };
